const INP = {
  width: '100%', padding: '10px 13px', borderRadius: 5,
  background: 'rgba(255,255,255,.05)', border: '1px solid rgba(201,168,76,.18)',
  color: '#fff', fontSize: '.84rem', fontFamily: 'var(--sans)',
  outline: 'none', boxSizing: 'border-box',
};
const LBL = {
  fontSize: '.6rem', color: 'rgba(255,255,255,.36)',
  letterSpacing: '.1em', textTransform: 'uppercase', marginBottom: 5, display: 'block',
};

function CharCount({ value, max }) {
  const len = (value || '').length;
  const ok  = len <= max;
  return (
    <span style={{
      fontSize: '.65rem',
      color: ok ? 'rgba(255,255,255,.28)' : '#f87171',
      float: 'right', marginTop: 3,
    }}>
      {len}/{max}
    </span>
  );
}

export default function Step6Seo({ form, update }) {
  const sectionHead = {
    color: 'rgba(255,255,255,.85)', fontSize: '.82rem', fontWeight: 700,
    marginBottom: '1rem', marginTop: '.5rem',
    paddingBottom: '.5rem', borderBottom: '1px solid rgba(201,168,76,.1)',
    display: 'flex', alignItems: 'center', gap: 7,
  };

  const seoPreviewTitle  = form.metaTitle  || form.name  || 'Project Title';
  const seoPreviewDesc   = form.metaDesc   || form.description || 'Project description will appear here...';
  const seoPreviewSlug   = form.slug       || 'project-slug';

  return (
    <div>
      <div style={sectionHead}>
        <span style={{ color: 'var(--gold)' }}>⑥</span> SEO & Routing
      </div>

      {/* URL Slug */}
      <div style={{ marginBottom: '.85rem' }}>
        <label style={LBL}>URL Slug</label>
        <div style={{ display: 'flex', alignItems: 'center', background: 'rgba(255,255,255,.03)', border: '1px solid rgba(201,168,76,.18)', borderRadius: 5, overflow: 'hidden' }}>
          <span style={{ padding: '10px 12px', color: 'rgba(255,255,255,.25)', fontSize: '.78rem', whiteSpace: 'nowrap', borderRight: '1px solid rgba(201,168,76,.12)', flexShrink: 0 }}>
            /projects/
          </span>
          <input
            id="step6-slug"
            name="slug"
            style={{ ...INP, border: 'none', background: 'transparent', borderRadius: 0 }}
            value={form.slug}
            onChange={e => update({ slug: e.target.value.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '') })}
            placeholder="auto-generated-from-name"
          />
        </div>
        <div style={{ fontSize: '.67rem', color: 'rgba(255,255,255,.2)', marginTop: 3 }}>
          Auto-generated from project name. Only lowercase letters, numbers, and hyphens.
        </div>
      </div>

      {/* Meta Title */}
      <div style={{ marginBottom: '.85rem' }}>
        <label style={LBL}>
          Meta Title
          <CharCount value={form.metaTitle} max={60} />
        </label>
        <input
          id="step6-meta-title"
          name="metaTitle"
          style={{
            ...INP,
            borderColor: (form.metaTitle || '').length > 60 ? 'rgba(248,113,113,.5)' : 'rgba(201,168,76,.18)',
          }}
          value={form.metaTitle}
          onChange={e => update({ metaTitle: e.target.value })}
          placeholder={form.name ? `${form.name} | Statia Luxury Real Estate` : 'Project Name | Statia'}
          maxLength={80}
        />
      </div>

      {/* Meta Description */}
      <div style={{ marginBottom: '1.4rem' }}>
        <label style={LBL}>
          Meta Description
          <CharCount value={form.metaDesc} max={160} />
        </label>
        <textarea
          id="step6-meta-desc"
          name="metaDesc"
          style={{
            ...INP, height: 80, resize: 'vertical',
            borderColor: (form.metaDesc || '').length > 160 ? 'rgba(248,113,113,.5)' : 'rgba(201,168,76,.18)',
          }}
          value={form.metaDesc}
          onChange={e => update({ metaDesc: e.target.value })}
          placeholder="Brief description of the project for search engines (max 160 characters)"
          maxLength={200}
        />
      </div>

      {/* SEO Preview Card */}
      <div style={{
        background: 'rgba(255,255,255,.03)', border: '1px solid rgba(201,168,76,.12)',
        borderRadius: 8, padding: '14px 16px',
      }}>
        <div style={{ fontSize: '.65rem', color: 'rgba(255,255,255,.25)', marginBottom: 8, letterSpacing: '.1em' }}>
          GOOGLE SEARCH PREVIEW
        </div>
        <div style={{ fontSize: '.72rem', color: 'rgba(255,255,255,.3)', marginBottom: 4 }}>
          https://www.statiarealestate.net/projects/<span style={{ color: 'rgba(201,168,76,.5)' }}>{seoPreviewSlug}</span>
        </div>
        <div style={{
          color: '#8ab4f8', fontSize: '.92rem', fontWeight: 500, marginBottom: 4,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {seoPreviewTitle.slice(0, 60)}
        </div>
        <div style={{
          color: 'rgba(255,255,255,.45)', fontSize: '.78rem', lineHeight: 1.5,
          overflow: 'hidden', display: '-webkit-box',
          WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
        }}>
          {seoPreviewDesc.slice(0, 160)}
        </div>
      </div>
    </div>
  );
}
